<template>
  <dialog
    ref="dialogRef"
    @click="onBackdropClick"
    @close="closeDialog"
    class="dialog-animation m-auto  bg-transparent p-0 backdrop:bg-slate-600/10 backdrop:backdrop-blur-[0.5px] backdrop:backdrop-filter"
    v-bind="$attrs"
  >
    <div :class="twMerge('max-h-[70vh] w-[85vw] rounded-md bg-white p-2 sm:w-[70vw] sm:max-w-[600px]', className)">
      <header v-if="withHeader" class="flex w-full items-start justify-end rounded-t">
        <button type="button" class="grid h-6 w-6 place-items-center rounded-md text-center text-gray-500 hover:bg-gray-300" @click="closeDialog">
          <img src="@/assets/icons/times.svg" class="w-4" alt="Close" />
        </button>
      </header>
      <div>
        <slot />
      </div>
    </div>
  </dialog>
</template>

<script>
import { twMerge } from "tailwind-merge";
// import closeIcon from '@/assets/icons/close.svg';

export default {
  props: {
    isScrollBlocked: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true, // Optional: close dialog when clicking on backdrop
    },
    withHeader: {
      type: Boolean,
      default: true, // Optional: close dialog when clicking on backdrop
    },
  },
  setup() {
    return {
      twMerge,
    };
  },
  data() {
    return {};
  },
  methods: {
    showDialog() {
      this.$refs.dialogRef?.showModal();
    },
    closeDialog() {
      this.$refs.dialogRef?.close();
      // For animation delay before actual close logic
      setTimeout(() => {
        this.$emit("close");
      }, 500);
    },
    onBackdropClick(e) {
      if (e.target === this.$refs.dialogRef && this.closeOnBackdropClick) {
        this.closeDialog();
      }
    },
    // External API for opening and closing dialog
    open() {
      this.showDialog();
    },
    close() {
      this.closeDialog();
    },
  },
  watch: {
    isScrollBlocked(newVal) {
      if (newVal) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "";
      }
    },
  },
  mounted() {
    this.showDialog();
  },
  beforeUnmount() {
    if (this.isScrollBlocked) {
      document.documentElement.style.overflow = "";
    }
  },
};
</script>

<style lang="sass" scoped></style>
<!-- .dialog-animation {
  opacity: 0;
  transition: all 0.3s allow-discrete;

  &::backdrop {
    opacity: 0;
    transition: all 0.5s allow-discrete;
  }

  &[open] {
    opacity: 1;

    &::backdrop {
      opacity: 1;
    }
  }
}

@starting-style {
  .dialog-animation {
    &[open] {
      opacity: 0;

      &::backdrop {
        opacity: 0;
      }
    }
  }
} -->
